// ./src/components/generic/form/useResponsiveDatePicker.ts
//
// Shared responsive behaviour for every date/time picker in the app.
//
// On phones a popover calendar is cramped and mis-positioned, and a
// DateTimePicker's popover can dismiss before you reach the time picker (so you
// end up unable to set the time). Rendering the calendar as a CENTERED MODAL
// fixes both: the whole calendar + time picker stay on screen until you confirm,
// and it sits in the middle of the viewport where it's easy to use. On larger
// screens we keep the lighter popover.
//
// Spread the result into any Mantine `DatePickerInput` / `DateInput` /
// `DateTimePicker` / `MonthPickerInput` / `YearPickerInput` so the behaviour is
// identical everywhere and tuned in one place.

import { useMediaQuery } from "@mantine/hooks";

// Phone breakpoint — matches the `sm` breakpoint (48em) and the mobile input
// guard in global.css.
const MOBILE_MEDIA_QUERY = "(max-width: 48em)";

export interface ResponsiveDatePickerProps {
  dropdownType: "popover" | "modal";
  modalProps?: { centered?: boolean };
}

export const useResponsiveDatePickerProps = (): ResponsiveDatePickerProps => {
  const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY);

  return isMobile
    ? { dropdownType: "modal", modalProps: { centered: true } }
    : { dropdownType: "popover" };
};
